import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useClosures } from "@/hooks/useClosures";
import { prettyDate } from "@/lib/studio";

const ClosureList = ({ closures, onRemove }) => (
  <div className="surface p-6 md:p-8 lg:col-span-7" data-testid="closure-list">
    <h2 className="mb-4 font-display text-lg font-semibold uppercase text-white">Upcoming closures</h2>
    {closures.length === 0 && <p className="text-sm text-zinc-500" data-testid="closure-list-empty">No closure days scheduled.</p>}
    <ul className="divide-y divide-white/5">
      {closures.map((c) => (
        <li key={c.id} className="flex items-center justify-between py-3" data-testid={`closure-item-${c.date}`}>
          <div>
            <p className="font-tech text-sm text-white">{prettyDate(c.date)}</p>
            <p className="text-xs text-zinc-500">{c.reason || "No reason given"}</p>
          </div>
          <button onClick={() => onRemove(c.id)} className="text-zinc-500 transition-colors hover:text-[#FF3333]" aria-label="Reopen day" data-testid={`closure-remove-${c.date}`}>
            <Trash2 className="h-4 w-4" />
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export const ClosuresPanel = ({ onChange }) => {
  const { closures, add, remove } = useClosures(onChange);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (await add(date, reason)) {
      setDate("");
      setReason("");
    }
  };

  return (
    <div className="grid gap-8 lg:grid-cols-12" data-testid="closures-panel">
      <form onSubmit={submit} className="surface space-y-4 p-6 md:p-8 lg:col-span-5" data-testid="closure-form">
        <h2 className="font-display text-lg font-semibold uppercase text-white">Close a day</h2>
        <p className="text-sm text-zinc-400">Nobody can book a closed day. Weekdays only.</p>
        <Input type="date" required value={date} onChange={(e) => setDate(e.target.value)} className="[color-scheme:dark]" data-testid="closure-date-input" />
        <Input placeholder="Reason (e.g. Public holiday, Maintenance)" maxLength={120} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="closure-reason-input" />
        <button type="submit" className="btn-riot w-full" data-testid="closure-submit-btn">Close this day</button>
      </form>
      <ClosureList closures={closures} onRemove={remove} />
    </div>
  );
};
